import { addCustomPanelMenuItem } from '../menu-item/add-custom-panel-menu-item';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { removeCustomPanelPageMenuItem } from '../menu-item/remove-custom-panel-page-menu-item';

export const customPanelPageMenuList: Array<ContextMenuList> = [
	addCustomPanelMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	removeCustomPanelPageMenuItem()
];
